import React from "react";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import BasicButton from "@components/button/BasicButton";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Container = styled.div({
  position: "relative",
  display: "flex",
  width: "100%",
  height: "100%",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});

const ContentBox = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "4rem",
  fontSize: "2.4rem",
  fontWeight: theme.fontWeight.medium,
}));

const ButtonWrapper = styled.div(({ theme }) => ({
  position: "absolute",
  width: "100%",
  bottom: "4.8rem",
  left: "0",
  zIndex: 10,
  padding: "0 2rem",
}));

const SuccessRegister = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const productId = location.state.productId;

  const handleNavigate = () => {
    navigate(`/product-detail/${productId}`, {
      replace: true,
    });
  };
  return (
    <Container>
      <ContentBox>
        <Image src={theme.image.check_circle.default} size="6rem" />
        <span>{t("등록이 완료되었습니다")}</span>
      </ContentBox>

      <ButtonWrapper>
        <BasicButton
          title="등록상품 확인하기"
          width="100%"
          height="5.2rem"
          onClick={handleNavigate}
        />
      </ButtonWrapper>
    </Container>
  );
};

export default SuccessRegister;
